import { Form } from 'factorial-form'
import { autorun } from 'mobx'

import asyncAction from 'modules/core/lib/asyncAction'

import type { Action } from 'modules/automations/store/models/Action'

import type { Storeable } from './Storeable'

export class RequestReview implements Storeable {
  #action: Action
  disposer: () => void
  form: Form

  constructor(action: Action) {
    this.#action = action
    this.form = new Form(
      {},
      {
        access_id: 'number',
      }
    )
    this.disposer = autorun(() => this._updateForm())
  }

  dispose() {
    this.disposer()
  }

  _updateForm() {
    return this.form.setValues({
      access_id: this.#action.metadata.access_id,
    })
  }

  async save() {
    if (!this.form.isDirty) return

    const { success } = await asyncAction(() =>
      this.#action.save({
        metadata: this.form.data(),
      })
    )

    if (success) this.form.cleanAll()
  }
}
